<template>
  <div class="inscript-hindi-lessons">
    <section class="hero is-warning is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            <b-tooltip label="Back" position="is-top" type="is-dark" animated>
              <a class="button" @click="$router.go(-1)">
                <b-icon icon="arrow-left"></b-icon>
              </a>
            </b-tooltip>
            <span style="margin-left: 0.5em"
              >Inscript हिन्दी Typing Lessons</span
            >
          </h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container is-fluid">
        <!-- Learn Lessons -->
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <h3 class="title has-text-centered">Learn Lessons</h3>
            </div>
          </div>
          <!-- Right side -->
          <div class="level-right">
            <p class="level-item">
              <b-field>
                <b-tooltip
                  label="Total Characters in typing content (Min: 50, Max: 1000)"
                  position="is-top"
                  animated
                >
                  <b-select
                    placeholder="Characters"
                    type="number"
                    v-model="inputTotalCharacters"
                    tabindex="1000"
                  >
                    <option v-for="nmbr in 20" :value="nmbr * 50" :key="nmbr">
                      {{ nmbr * 50 }}
                    </option>
                  </b-select>
                </b-tooltip>

                <b-tooltip
                  label="Typing Time Duration"
                  position="is-top"
                  animated
                >
                  <b-select
                    v-model="selectTimeDuration"
                    placeholder="Select Time for Test"
                  >
                    <option
                      v-for="option in listTimeDuration"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-tooltip>
              </b-field>
            </p>
          </div>
        </nav>
        <hr />
        <b-collapse
          class="panel"
          v-for="(bl, index) in listLearnLessons"
          :key="index"
          :open.sync="collapseOpenData[bl.id].top"
        >
          <div slot="trigger" class="panel-heading">
            <strong>{{ bl.name }}</strong>
          </div>
          <p class="panel-tabs">
            <a
              v-bind:class="{ 'is-active': collapseOpenData[bl.id].wOShift }"
              @click="collapseAction(bl.id, 'wOShift')"
              >Without Shift Key</a
            >
            <a
              v-bind:class="{ 'is-active': collapseOpenData[bl.id].wShift }"
              @click="collapseAction(bl.id, 'wShift')"
              >With Shift Key</a
            >
          </p>
          <div class="panel-block">
            <b-collapse
              class="panel"
              :open.sync="collapseOpenData[bl.id].wOShift"
              animation
            >
              <div class="columns is-multiline">
                <div
                  class="column"
                  v-for="(shiftLessons, index) in bl.withoutShift"
                  :key="index"
                  v-bind:class="applyLessonClass('column', shiftLessons.title)"
                >
                  <div
                    class="card"
                    @click="
                      $router.push(
                        '/learn/hindi/inscript/' +
                          encodeString(shiftLessons.title)
                      )
                    "
                  >
                    <header
                      class="card-header"
                      v-bind:class="
                        applyLessonClass('header', shiftLessons.title)
                      "
                    >
                      <p class="card-header-title">
                        <router-link
                          class="has-text-white"
                          :to="
                            '/learn/hindi/inscript/' +
                            encodeString(shiftLessons.title)
                          "
                        >
                          {{ shiftLessons.title }}
                        </router-link>
                      </p>
                    </header>
                    <div
                      style="padding: 0.8rem"
                      class="
                        card-content
                        has-text-centered has-text-weight-bold
                        is-size-3
                      "
                      v-bind:class="
                        applyLessonClass('content', shiftLessons.index)
                      "
                    >
                      <div class="content">
                        {{ shiftLessons.name }}
                        <span v-if="shiftLessons.key"
                          >({{ shiftLessons.key }})</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
            <b-collapse
              class="panel"
              :open.sync="collapseOpenData[bl.id].wShift"
              animation
            >
              <div class="columns is-multiline">
                <div
                  class="column"
                  v-for="(outShiftLessons, index) in bl.withShift"
                  :key="index"
                  v-bind:class="
                    applyLessonClass('column', outShiftLessons.title)
                  "
                >
                  <div
                    class="card"
                    style="cursor: pointer"
                    @click="
                      $router.push(
                        '/learn/hindi/inscript/' +
                          encodeString(outShiftLessons.title)
                      )
                    "
                  >
                    <header
                      class="card-header"
                      v-bind:class="
                        applyLessonClass('header', outShiftLessons.title)
                      "
                    >
                      <p class="card-header-title">
                        <router-link
                          class="has-text-white"
                          :to="
                            '/learn/hindi/inscript/' +
                            encodeString(outShiftLessons.title)
                          "
                        >
                          {{ outShiftLessons.title }}
                        </router-link>
                      </p>
                    </header>
                    <div
                      style="padding: 0.8rem"
                      class="
                        card-content
                        has-text-centered has-text-weight-bold
                        is-size-3
                      "
                      v-bind:class="
                        applyLessonClass('content', outShiftLessons.title)
                      "
                    >
                      <div class="content">
                        {{ outShiftLessons.name }}
                        <span v-if="outShiftLessons.key"
                          >({{ outShiftLessons.key }})</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </section>
  </div>
</template>

<script>
import { Base64 } from "js-base64";

export default {
  name: "inscript-hindi-lessons",
  data() {
    return {
      collapseOpenData: {
        R1: {
          top: true,
          wOShift: true,
          wShift: false,
        },
        R2: {
          top: false,
          wOShift: true,
          wShift: false,
        },
        R3: {
          top: false,
          wOShift: true,
          wShift: false,
        },
      },
    };
  },

  computed: {
    lessonsList() {
      return this.$store.state.ihl.lessons;
    },
    listLearnLessons() {
      return this.$store.state.ihl.learnLessons;
    },
    listTimeDuration() {
      return this.$store.state.ihl.listTimeDuration;
    },
    selectTimeDuration: {
      get() {
        return this.$store.state.ihl.selectedTimeDuration;
      },
      set(val) {
        this.$store.commit("ihl/UP_TIME_DURATION", val);
      },
    },
    inputTotalCharacters: {
      get() {
        return this.$store.state.ihl.totalCharacters;
      },
      set(val) {
        this.$store.commit("ihl/UP_TOTAL_CHARACTERS", val);
      },
    },
  },

  methods: {
    encodeString(title) {
      let index = title.split(" ")[1].trim();
      index = parseInt(index) - 1;
      return Base64.encode(index);
    },

    /**
     * Apply Lesson Card Class Name
     * @param: type
     * @param: data
     */
    applyLessonClass(type, data) {
      if (
        data === "Lesson 3" ||
        data === "Lesson 6" ||
        data === "Lesson 11" ||
        data === "Lesson 14" ||
        data === "Lesson 19" ||
        data === "Lesson 22" ||
        data === "Lesson 25" ||
        data === "Lesson 29" ||
        data === "Lesson 32" ||
        data === "Lesson 35" ||
        data === "Lesson 39" ||
        data === "Lesson 42" ||
        data === "Lesson 47" ||
        data === "Lesson 50"
      ) {
        if (type === "header") {
          return "has-background-danger";
        } else if (type === "content") {
          return "has-text-danger";
        }
      } else if (
        data === "Lesson 8" ||
        data === "Lesson 16" ||
        data === "Lesson 26" ||
        data === "Lesson 36" ||
        data === "Lesson 44" ||
        data === "Lesson 52"
      ) {
        if (type === "header") {
          return "has-background-info";
        } else if (type === "content") {
          return "has-text-info";
        }
      } else {
        if (type === "header") {
          return "has-background-primary";
        }
      }

      // If Type is Column
      if (type === "column") {
        if (
          data === "Lesson 8" ||
          data === "Lesson 16" ||
          data === "Lesson 44" ||
          data === "Lesson 52"
        ) {
          return "is-10";
        } else if (data === "Lesson 26" || data === "Lesson 36") {
          return "is-6";
        }
        return "is-2";
      }
    },

    /**
     * Open & Close Collapse
     */
    collapseAction(ch, key) {
      if (key === "wShift") {
        this.collapseOpenData[ch].wOShift = false;
        this.collapseOpenData[ch].wShift = true;
      } else if (key === "wOShift") {
        this.collapseOpenData[ch].wShift = false;
        this.collapseOpenData[ch].wOShift = true;
      }
    },
  },

  watch: {
    collapseOpenData: {
      handler: function (newObject) {
        localStorage.setItem(
          "inscript_lessons_collapse",
          JSON.stringify(newObject)
        );
      },
      deep: true,
    },
  },

  created() {
    // Fetch Collapse Data in localStorage
    var inscript_lessons_collapse = localStorage.getItem(
      "inscript_lessons_collapse"
    );
    if (
      inscript_lessons_collapse !== null &&
      inscript_lessons_collapse !== undefined
    ) {
      this.collapseOpenData = JSON.parse(inscript_lessons_collapse);
    }
  },

  mounted() {
    this.$Progress.finish();
  },
};
</script>
